<template>
  <v-checkbox
    v-model="roleIsSelected"
    @change="selectClientRole(clientRole)"
    :label="clientRole.label"
    :ripple="false"
    :indeterminate="indeterminateState"
    hide-details
    color="#4fa2b7"
    @click.stop=""
  />
</template>

<script>
export default {
  name: "PermissionClientRoleItem",

  props: {
    clientRole: {
      type: Object
    },

    permissionsSelected: Array,
    clientRolesSelected: {}
  },

  data() {
    return {
      roleIsSelected: false,
      rolePermissionsSelected: [],
      indeterminateState: false,
      allPermissionInClientRole: []
    };
  },

  watch: {
    clientRolesSelected(clientRoles) {
      this.roleIsSelected = clientRoles.includes(this.clientRole);
      if (!clientRoles.includes(this.clientRole)) {
        this.indeterminateState = false;
      }
    },

    permissionsSelected() {
      this.updateClientRoleState();
    }
  },

  mounted() {
    this.getAllPermissionsInClientRole();
    this.roleIsSelected = this.clientRolesSelected.includes(this.clientRole);
    this.updateClientRoleState();
  },

  methods: {
    selectClientRole(clientRole) {
      this.$emit("selectClientRole", clientRole);
    },

    getAllPermissionsInClientRole() {
      let allPermissions = [];
      if (this.clientRole) {
        for (let role of this.clientRole.permissions) {
          for (let permission of role.permissions) {
            allPermissions.push(permission.id);
          }
        }
      }
      this.allPermissionInClientRole = allPermissions;
    },

    updateClientRoleState() {
      if (
        this.clientRole !== undefined &&
        this.permissionsSelected !== undefined
      ) {
        if (this.roleIsSelected) {
          let intersectionPermissions = this.allPermissionInClientRole.filter(
            x => this.permissionsSelected.includes(x)
          );
          if (intersectionPermissions.length === 0) {
            this.selectClientRole(this.clientRole);
          }
          this.indeterminateState =
            intersectionPermissions.length !==
            this.allPermissionInClientRole.length;
        } else {
          this.indeterminateState = false;
        }
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/SystemManagement/Accounts/Permissions/PermissionsClientRoleItem.vue